import { render, staticRenderFns } from "./detailDiff.vue?vue&type=template&id=fc3a5052&scoped=true"
import script from "./detailDiff.vue?vue&type=script&lang=js"
export * from "./detailDiff.vue?vue&type=script&lang=js"
import style0 from "./detailDiff.vue?vue&type=style&index=0&id=fc3a5052&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc3a5052",
  null
  
)

export default component.exports